import layer from 'vue-layer-mobile'
import {nError} from './notice'
import {errorMessage} from './errorCode'
// import {isResponse} from './util'

const errorHandler = message => error => {
  Promise.resolve(generateErrorInfo(message)(error))
    .then((data) => {
      if (data) {
        if (data.tip && data.tip !== '') {
          nError(data.tip)
        }
      }
    })
}

const theExceptionIsReturnedByServer = (error, also) => {
  return {
    also,
    fromServer: true,
    level: 0,
    type: '',
    error
  }
}

const theExceptionIsGeneratedByClient = (error) => {
  return error
}

const generateErrorInfo = message => error => {
  let err = JSON.stringify(error)
  let res = JSON.parse(err).response
  if (res) {
    if (res.status === 302 && res.data === 'gotologin') {
      layer.toast({
        icon: 'icon-check',
        content: '您未登录或登录信息已过期，请重新登录',
        time: 3000
      })
      window.$$vm.$router.push({
        name: 'login'
      })
      return
    }
    if (res.status === 403) {
      return {
        tip: null,
        fullStack: theExceptionIsReturnedByServer(error)
      }
    }
    if (res.status === 401) {
      layer.toast({
        icon: 'icon-check',
        content: '您没有该操作的权限',
        time: 3000
      })
      window.$$vm.$router.push({
        name: 'login'
      })
      return
    }
    if (res.status === 409) {
      if (+res.data.data > 1000) {
        let TipData = errorMessage(+res.data.data)
        return {
          tip: TipData,
          fullStack: theExceptionIsReturnedByServer(error)
        }
      } else {
        return {
          tip: res.data.data,
          fullStack: theExceptionIsReturnedByServer(error)
        }
      }
    }
    if (res.status >= 400 && res.status < 500) {
      if (+res.data.data > 1000) {
        let TipData = errorMessage(+res.data.data)
        return {
          tip: TipData,
          fullStack: theExceptionIsReturnedByServer(error)
        }
      } else {
        return {
          tip: res.data.data,
          fullStack: theExceptionIsReturnedByServer(error)
        }
      }
    }
    if (res.status >= 500) {
      return {
        tip: message,
        fullStack: theExceptionIsReturnedByServer(error)
      }
    }
    if (res.status !== 200) {
      const also = `无法识别的HTTP状态码${res.status}`
      return {
        tip: message,
        fullStack: theExceptionIsReturnedByServer(error, also)
      }
    }
  }

  // 不存在error对象
  if (!res) {
    return {
      tip: message,
      fullStack: theExceptionIsGeneratedByClient(message)
    }
  }

  // error 为具体的 Error对象
  if (error instanceof Error && error._message_) {
    return {
      tip: error._message_,
      fullStack: theExceptionIsGeneratedByClient(error)
    }
  }

  // 貌似一切正常
  if (error.msg === 'success' && error.retCode === 1) {
    return {
      tip: null,
      fullStack: theExceptionIsGeneratedByClient({
        message: '异常处理程序捕获到一个服务端返回结果，但这个结果貌似正常',
        error
      })
    }
  }

  if (error.msg === 'fail' && error.retCode === 0 && error.data) {
    return {
      tip: error.data,
      fullStack: theExceptionIsReturnedByServer(error, '服务端使用了旧的错误返回机制')
    }
  }

  return {
    tip: message,
    fullStack: theExceptionIsGeneratedByClient(error)
  }
}

export const loge = e => e && console.error(e)

export const createAnErrorWithTip = (tipInfo, message) => {
  const error = new Error(message || tipInfo)
  error._message_ = tipInfo
  return error
}

/**
 * 如果数据为 非（null, undefined, false, 0等）
 * 提示用户异常
 * @param message 提示消息
 * data 数据
 */
export const ifNullGenerateTipping = message => data => {
  if (!data) {
    return Promise.reject(createAnErrorWithTip(message))
  }
  return data
}

export default errorHandler
export {errorHandler}



// WEBPACK FOOTER //
// ./src/util/errorHandler.js